var map = {
	"./symbol_0.png": 94128,
	"./symbol_1.png": 377,
	"./symbol_2.png": 33794,
	"./symbol_3.png": 7947,
	"./symbol_4.png": 58036,
	"./symbol_5.png": 79165,
	"./symbol_6.png": 97958
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91587;